import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MachineGroup} from "../model/machine-group";
import {MachineGroupPersistRequest} from "../model/requests/machine-group-persist-request";
import {MachineGroupFilters} from "../model/filters/machine-group-filters";
import {HttpUtils} from "../shared/http.utils";
import {FiltersUtils} from "../shared/filters.utils";

@Injectable({
  providedIn: 'root'
})
export class MachineGroupsService {

  private readonly machineGroupsURL: string;


  constructor(private http: HttpClient) {
    this.machineGroupsURL = '/api/groups';
  }

  public getGroups(offset?: number, limit?: number, filters?: MachineGroupFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    if (filters != null) {
      options.params["name"] = FiltersUtils.getFilterTrim(filters.name);
      options.params["serialNumbers"] = FiltersUtils.getFilter(filters.serialNumbers);
    }
    return this.http.get<any>(this.machineGroupsURL, options);
  }

  public getGroupsSummary(): Observable<{ machineGroups: MachineGroup[] }> {
    const url: string = `${this.machineGroupsURL}/summary`;
    return this.http.get<any>(url);
  }

  public getMachineGroupByUuid(machineGroupUuid: string): Observable<{ machineGroup: MachineGroup }> {
    return this.http.get<{ machineGroup: MachineGroup }>(`${this.machineGroupsURL}/${machineGroupUuid}`);
  }

  public createGroup(machineGroupData: MachineGroupPersistRequest): Observable<any> {
    return this.http.post<any>(this.machineGroupsURL, machineGroupData);
  }

  public editGroup(machineGroupData: MachineGroupPersistRequest): Observable<any> {
    const url: string = `${this.machineGroupsURL}/${machineGroupData.machineGroupUuid}`;
    return this.http.put<any>(url, machineGroupData);
  }

  public deleteGroup(machineGroupUuid: string): Observable<any> {
    const url: string = `${this.machineGroupsURL}/${machineGroupUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

}
